import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95a785f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-3 mb-5 me-3\" data-v-95a785f6><div class=\"col-2\" data-v-95a785f6><img src=\"/img/SPSF_web.png\" class=\"img-fluid\" width=\"100\" data-v-95a785f6></div><div class=\"col-10 text-end\" data-v-95a785f6><p class=\"title\" data-v-95a785f6>Svenska Mästerskap 2024</p></div></div>", 1)
const _hoisted_2 = { class: "row row-cols-1 row-cols-md-2 g-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Mer information finns att läsa i Svenska Pistolskytteförbundets "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.pistolskytteforbundet.se/stomprogram/stomprogram-2022/",
      target: "_blank"
    }, "stomprogram för 2024"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Competition = _resolveComponent("Competition")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Competition, {
        name: "Fältskjutning",
        dates: "2-7 juli",
        description: "Malmö",
        url: "https://pistolsm2024.se/"
      }),
      _createVNode(_component_Competition, {
        name: "Militär snabbmatch",
        dates: "2-7 juli",
        description: "Malmö",
        url: "https://pistolsm2024.se/"
      }),
      _createVNode(_component_Competition, {
        name: "Precisionsskjutning",
        dates: "2-7 juli",
        description: "Malmö",
        url: "https://pistolsm2024.se/"
      }),
      _createVNode(_component_Competition, {
        name: "Magnumprecision",
        dates: "7-9 juni",
        description: "Uppsala",
        url: ""
      }),
      _createVNode(_component_Competition, {
        name: "Magnumfältskjutning",
        dates: "20-21 juli",
        description: "Norrköping",
        url: ""
      }),
      _createVNode(_component_Competition, {
        name: "PPC",
        dates: "27-28 juli",
        description: "Hagfors",
        url: ""
      }),
      _createVNode(_component_Competition, {
        name: "Springskytte",
        dates: "24 augusti",
        description: "Uppsala",
        url: ""
      })
    ]),
    _hoisted_3
  ]))
}